import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import AppLayout from '@/components/AppLayout';
import ProtectedRoute from '@/components/ProtectedRoute';
import GalleryPage from '@/pages/GalleryPage';
import RunPage from '@/pages/RunPage';
import StatusPage from '@/pages/StatusPage';
import HistoryPage from '@/pages/HistoryPage';
import ExecutionDetailPage from '@/pages/ExecutionDetailPage';
import OutputsGridPage from '@/pages/OutputsGridPage';
import InputsPage from '@/pages/InputsPage';
import ApiTokensPage from '@/pages/ApiTokensPage';
import IntegrationsPage from '@/pages/IntegrationsPage';
import DevPage from '@/pages/DevPage';
import SettingsPage from '@/pages/SettingsPage';
import WorkflowsPage from '@/pages/WorkflowsPage';
import WorkflowNewPage from '@/pages/WorkflowNewPage';
import WorkflowDetailPage from '@/pages/WorkflowDetailPage';
import GroupsPage from '@/pages/GroupsPage';
import AnalyticsPage from '@/pages/AnalyticsPage';

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <GalleryPage /> },
      { path: '/run/:id', element: <RunPage /> },
      { path: '/run/:id/status/:promptId', element: <StatusPage /> },
      { path: '/history', element: <HistoryPage /> },
      { path: '/history/:promptId', element: <ExecutionDetailPage /> },
      { path: '/outputs', element: <OutputsGridPage /> },
      { path: '/inputs', element: <InputsPage /> },
      { path: '/tokens', element: <ApiTokensPage /> },
      { path: '/integrations', element: <IntegrationsPage /> },
      { path: '/dev', element: <DevPage /> },
      {
        path: '/admin/workflows',
        element: (
          <ProtectedRoute requiredRole="workload-manager">
            <WorkflowsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/admin/workflows/new',
        element: (
          <ProtectedRoute requiredRole="workload-manager">
            <WorkflowNewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/admin/workflows/:id',
        element: (
          <ProtectedRoute requiredRole="workload-manager">
            <WorkflowDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/admin/settings',
        element: (
          <ProtectedRoute requireAdmin>
            <SettingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/admin/groups',
        element: (
          <ProtectedRoute requiredRole="workload-manager">
            <GroupsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/admin/analytics',
        element: (
          <ProtectedRoute requiredRole="workload-manager">
            <AnalyticsPage />
          </ProtectedRoute>
        ),
      },
      // Catch-all: redirect any unmatched route to the home page.
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
